import type { TMessages } from '@/types/TMessages'

export const messages = {
  questionnaire: 'Анкета контрагента',
  landBankRegistry: 'Реестр земельного банка',
  personalDataProcessing: 'Согласие на обработку перс данных',
  bKIForLegalEntities: 'Согласие БКИ для ЮЛ',
  bKIForIndividual: 'Согласие БКИ для ИП и ФЛ',
  documentList: 'Список документов',
} satisfies TMessages
